import { graphql } from '@/_gql'

export const GqlGeoCountries = graphql(`
  query GetCountries($request: GetCountriesRequest!) {
    getCountries(request: $request) {
      data {
        id
        name
      }
    }
  }
`)

export const GqlGeoProvinces = graphql(`
  query GetProvinces($request: GetProvincesRequest!) {
    getProvinces(request: $request) {
      data {
        id
        name
      }
    }
  }
`)

export const GqlGeoCities = graphql(`
  query GetCities($request: GetCitiesRequest!) {
    getCities(request: $request) {
      data {
        id
        name
      }
    }
  }
`)
